import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import Header from '../Header';
import SideNavigation from '../SideNavigation';
import { ContentLayout, LayoutContainer } from './Layout.style';
export var HEADER_HEIGHT = 60;
export function Layout() {
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Header, {
                height: HEADER_HEIGHT
            }),
            /*#__PURE__*/ _jsx(LayoutContainer, {
                $marginTop: HEADER_HEIGHT,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "with-sidebar",
                    children: [
                        /*#__PURE__*/ _jsx(SideNavigation, {}),
                        /*#__PURE__*/ _jsx(ContentLayout, {
                            $marginTop: HEADER_HEIGHT,
                            children: /*#__PURE__*/ _jsx(Outlet, {})
                        })
                    ]
                })
            })
        ]
    });
}
